import { Component, inject } from '@angular/core';
import { ImageSideComponent } from '../../image-side/image-side.component';
import { CardsComponent } from '../../cards/cards.component';
import { Router } from '@angular/router';
import { GlobalService } from '../../../services/common/global.service';
import { LoaderService } from '../../../services/loader/loader.service';
import { AuthService } from '../../../services/auth.service';
import { profileSetting } from '../../../common/profile-setting';
import { CommonModule } from '@angular/common';
import { RouteUtils } from '../../../services/utils/route-utils';

@Component({
  selector: 'app-user-type-screen',
  imports: [ImageSideComponent,CardsComponent,CommonModule],
  templateUrl: './user-type-screen.component.html',
  styleUrl: './user-type-screen.component.scss'
})
export class UserTypeScreenComponent {
  globalService = inject(GlobalService);
  authService = inject(AuthService);
  userSettings!:any;
  profileSettingData = profileSetting
  private loadingService = inject (LoaderService);
  router = inject (Router);
  constructor(){
    this.userSettings = JSON.parse(this.globalService.getUserSettings());
    // Auto-select the first visible card if only one
    // const visibleCards = this.profileSettingData.filter((item: any) => this.isCardVisible(item));
    // if (visibleCards.length === 1) {
    //   this.cardEvent(visibleCards[0].cardTitle);
    // }
  }
  isCardVisible(item: any): boolean {
    return this.userSettings.userPermissions.some((permission:any) => permission.module_name === item.cardTitle && permission.is_assigned);
  }
  cardEvent(item:any){
    if(item?.externalUrl){
      window.open(item.externalUrl, '_blank');
      return;
    }
    const value = item?.isActive ?? item;
    this.loadingService.showSpinner();
   this.globalService.setUserRole(value);
    //setting for Menus
    RouteUtils.initMenu(this.globalService.getUserRole(),JSON.parse(this.globalService.getUserSettings()))
  this.router.navigateByUrl('/dashboard').then(() => {
    this.loadingService.stopSpinner();
  });
  }
}
